import React from "react";
import {DataTableColumnProps} from "peggirkit";
import {IntlShape} from "react-intl";
import ViewFormatter from "@widgets/employees/overview/table/columns/ViewFormatter";
import CodeFormatter from "@widgets/employees/overview/table/columns/CodeFormatter";
import {editEmployee} from "@/routing/Router";
import {EmployeeTimeEntry} from "@/data/entities/employee";
import ClockedInFormatter from "@widgets/employees/overview/table/columns/ClockedInFormatter";
import {EmployeeInDataTable} from "@widgets/employees/overview/Employees";

export const getEmployeesDataTableColumns = (intl: IntlShape): DataTableColumnProps<EmployeeInDataTable>[] => ([
    {
        id: "id",
        label: {displayName: intl.formatMessage({id: "id"})},
        primary: false,
        visibility: "always-hidden",
    },
    {
        id: "code",
        label: {displayName: intl.formatMessage({id: "code"})},
        primary: false,
        sortingConfig: {enabled: true},
        formatter: (code: string,) => <CodeFormatter code={code}/>,
    },
    {
        id: "firstName",
        label: {displayName: intl.formatMessage({id: "firstName"})},
        primary: true,
        sortingConfig: {enabled: true},
    },
    {
        id: "lastName",
        label: {displayName: intl.formatMessage({id: "lastName"})},
        primary: true,
        sortingConfig: {
            enabled: true,
            sorted: "asc",
        },
    },
    {
        id: "emailAddress",
        label: {displayName: intl.formatMessage({id: "emailAddress"})},
        primary: false,
        sortingConfig: {enabled: true},
        visibility: "md",
        formatter: (emailAddress: string | null) => emailAddress || "-",
    },
    {
        id: "latestTimeEntry",
        label: {displayName: intl.formatMessage({id: "clockedIn"})},
        primary: false,
        sortingConfig: {
            enabled: false,
        },
        align: "right",
        formatter: (timeEntry: EmployeeTimeEntry | null) => <ClockedInFormatter timeEntry={timeEntry}/>,
    },
    {
        id: "options",
        label: {
            displayName: intl.formatMessage({id: "view"}),
            hide: true,
        },
        primary: false,
        sortingConfig: {
            enabled: false,
        },
        align: "right",
        formatter: (_, {id}) => <ViewFormatter to={editEmployee(id).absolutePath()}/>,
    },
]);